import Vue from "vue";
import api from "../../api/safe";

// initial state
const state = {
  i18n: undefined,
  updatingSelected: false,
  loading: false,
  invoices: {
    paginator: { data: [], meta: { per_page: 10 } },
    selected: undefined,
  },
  bonusesData: undefined,
  form: undefined,
  showDetail: false,
  routes: undefined,
};

const actions = {
  getDetail({ commit }, invoiceId) {
    commit("setUpdatingSelected", true);
    let endpoint = state.routes.invoices.show.replace(":id", invoiceId);
    api.getInvoiceDetail(endpoint, (detail) => {
      commit("setSelectedRefill", detail);
      commit("setUpdatingSelected", false);
      commit("updateRefill", detail);
    });
  },

  getPaginator({ commit }, queryString) {
    let endpoint = state.routes.invoices.index;

    if (queryString) {
      endpoint += "?" + queryString;
    }

    commit("setLoading", true);

    api.getInvoices(endpoint, (paginator) => {
      commit("setPaginator", paginator);
    });
  },
};

const getters = {
  getSelectedRefill(state) {
    return state.invoices.selected;
  },
};

const mutations = {
  setTranslations(state, i18n) {
    state.i18n = i18n;
  },

  setPaginator(state, paginator) {
    if (paginator.meta !== undefined) {
      state.invoices.paginator = paginator;
    } else {
      state.invoices.paginator.data = paginator.data;
    }

    state.loading = false;
  },

  setSelectedRefill(state, selected) {
    state.invoices.selected = selected;
  },

  addRefill(state, refill) {
    this.commit("account/increaseRefillsCount");
    this.commit("safe/setSelectedRefill", refill);

    if (
      state.invoices.paginator.meta.total === undefined &&
      state.invoices.paginator.data.length === 10
    ) {
      this.dispatch("safe/getPaginator");
    } else {
      if (
        state.invoices.paginator.data.length ==
        state.invoices.paginator.meta.per_page
      ) {
        state.invoices.paginator.data.pop();
      }

      state.invoices.paginator.data.unshift(refill);
    }
  },

  updateRefill(state, updated) {
    if (state.invoices.paginator !== undefined) {
      let refill = state.invoices.paginator.data.find(
        (refill) => refill.id === updated.id
      );
      let index = state.invoices.paginator.data.indexOf(refill);
      Vue.set(state.invoices.paginator.data, index, updated);
    }
  },

  setBonusesData(state, data) {
    state.bonusesData = data;
  },

  setForm(state, form) {
    state.form = form;
  },

  setRoutes(state, routes) {
    state.routes = routes;
  },

  showDetail(state) {
    state.showDetail = true;
  },

  hideDetail(state) {
    state.showDetail = false;
  },

  setUpdatingSelected(state, status) {
    state.updatingSelected = status;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
